// ============================================================================
// COMBINED TRANSACTION SERVICE
// ============================================================================

import { get, post, put, patch, del } from '../client/axiosClient';
import { combinedEndpoints } from '../endpoints/combined.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse,
  PaginatedResponse,
  ID,
} from '../types';
import { transformPaginatedResponse } from '../types/common.types';
import type {
  CombinedTransaction,
  CreateCombinedPayload,
  UpdateCombinedPayload,
  CombinedFilterParams,
} from '../types/combined.types';

class CombinedService {
  async getAll(params?: CombinedFilterParams): Promise<PaginatedResponse<CombinedTransaction>> {
    const endpoint = params
      ? buildEndpointWithQuery(combinedEndpoints.list(), params)
      : combinedEndpoints.list();
    const response = await get(endpoint);
    return transformPaginatedResponse<CombinedTransaction>(response.data);
  }

  async getById(id: ID): Promise<ApiResponse<CombinedTransaction>> {
    const response = await get<ApiResponse<CombinedTransaction>>(combinedEndpoints.getById(id));
    return response.data;
  }

  async create(payload: CreateCombinedPayload): Promise<ApiResponse<CombinedTransaction>> {
    const response = await post<ApiResponse<CombinedTransaction>>(combinedEndpoints.create(), payload);
    return response.data;
  }

  async update(id: ID, payload: UpdateCombinedPayload): Promise<ApiResponse<CombinedTransaction>> {
    const response = await put<ApiResponse<CombinedTransaction>>(combinedEndpoints.update(id), payload);
    return response.data;
  }

  async submit(id: ID): Promise<ApiResponse<CombinedTransaction>> {
    const response = await patch<ApiResponse<CombinedTransaction>>(combinedEndpoints.submit(id), {});
    return response.data;
  }

  async delete(id: ID): Promise<ApiResponse<void>> {
    const response = await del<ApiResponse<void>>(combinedEndpoints.delete(id));
    return response.data;
  }
}

export const combinedService = new CombinedService();
export default combinedService;
